var app = angular.module('leonardo');

var ADirective = function(ConfigThemeService) {
  return {
    restrict: 'E',
    scope: {
      aColor: '@',
      aBorderColor: '@',
      aBackgroundColor: '@'
    },
    link: function (scope, element) {

      scope.setColor = function() {
        var color = scope.aColor ? ConfigThemeService.getColor(scope.aColor) : ConfigThemeService.config.theme_config.secondaryColor;
        element.css('color', color);
        if (scope.aBorderColor) {
          element.css('border-color', ConfigThemeService.getColor(scope.aBorderColor));
        }
        if (scope.aBackgroundColor) {
          element.css('background-color', ConfigThemeService.getColor(scope.aBackgroundColor));
        }
      };

      scope.setColor();


      scope.$on('config-theme:updated', function () {
        scope.setColor();
      });
    }
  };
};

app.directive('a', ['ConfigThemeService', ADirective]);
